import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { PaymentDeiails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from 'src/app/services/payment.service';
import { VerifypatientService } from '../../services/verifypatient.service';
import { CreateICDRequest, requestICD } from '../../models/symtomChecker/symptomsChecker';
import { SymptomsCheckerService } from 'src/app/services/symptoms-checker.service';
import { SymptommsModel } from '../../models/careteam/careteam';
import { CareTEamService } from '../../services/care-team.service';
@Component({
  selector: 'app-payment',
  templateUrl: './payment-overview.component.html',
  styleUrls: ['./payment-overview.component.css']
})
export class PaymentOverviewComponent implements OnInit {

  @Input() nextClicked = new EventEmitter<boolean>();

  patientpersonalinfo: any;
  isCopay: any = false;
  isoutstanding: any = false;
  amount: any = '';
  amountDueTemp: number;
  isMinAmount: boolean = true;
  paymentForm: FormGroup = new FormGroup({});
  selectedBox: string="";
  paymentType: any;
  ShowAmountField: boolean = true;
  sympTomsModel!: SymptommsModel;
  storedIsWithin24Hours: any;
  appointmentId: any;
  isCheckedin: any = false;
  payLaterButton: any = true;
  hidebackButton: boolean = false;
  showMessage: boolean = false;
  reasonName: any = '';
  constructor(private translateService: TranslateService, private _location: Location, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private service: PaymentService, private _router: Router, private _VerifypatientService: VerifypatientService,
    private SymptomsCheckerService: SymptomsCheckerService, private careTeamService: CareTEamService) {
    // console.log("payment component");
    let info1 = localStorage.getItem('PersonalInfo');
    if(!info1){
      this._router.navigateByUrl("/");
      return;
    }
    this.patientpersonalinfo = this.phrUtils.decrypt(localStorage.getItem('PersonalInfo'));
    const reason = localStorage.getItem('reason');
    if (reason == null || reason == undefined) {
      this.reasonName = '';
    } else {
      this.reasonName = reason;
    }
    // console.log(this.patientpersonalinfo);
  }
  AppointmentStatusId: any;
  ngOnInit(): void {
    const appstId = localStorage.getItem("apptstId");
    if (appstId == null || appstId == undefined || appstId == '') {
      this.AppointmentStatusId = '';
    } else {
      this.AppointmentStatusId = appstId;
      // console.log("inside appointment id  ", apptid);
    }
    this.storedIsWithin24Hours = localStorage.getItem('isWithin24Hours');
    const apptid = localStorage.getItem("apptId")
    // console.log("appointment id  ", apptid);
    if (apptid == null || apptid == undefined || apptid == '') {
      this.appointmentId = '';
    } else {
      this.appointmentId = apptid;
      // console.log("inside appointment id  ", apptid);
    }
    const isPayLaterEnabled = localStorage.getItem("isPayLaterEnabled");
    console.log("isPayLaterEnabled in payment  ", isPayLaterEnabled);

    if (isPayLaterEnabled == null || isPayLaterEnabled == undefined || isPayLaterEnabled == '') {
      this.payLaterButton = true;
    } else {
      if (isPayLaterEnabled == "0")
        this.payLaterButton = false;
      else
        this.payLaterButton = true;
      // console.log("inside appointment id  ", apptid);
    }
    localStorage.removeItem("pType");
    this.getPaymentDetails();
    this.phrUtils.patientlanguage$.subscribe(language => {
      if (language === 'es') {
        this.phrUtils.setTitle('Saldo deudor');
      } else if (language === 'hi') {
        this.phrUtils.setTitle('शेष राशि');
      }
      else if (language === 'ur') {
        this.phrUtils.setTitle('بقایا بیلنس');
      }
      else {
        this.phrUtils.setTitle('Balance Due');
      }
    });

    this.buildpaymentForm();
    //check if already checkin
    const ischeckin = localStorage.getItem("checkin")
    if (ischeckin !='true') {
      //this.UpdateAppointmentstatus();

      this.sympTomsModel = new SymptommsModel();
      if (this.patientpersonalinfo.REASON_NAME) {
        console.log("inside ds reason");
        this.sympTomsModel.visitReason = this.patientpersonalinfo.REASON_NAME.toLowerCase();
      } else {
        console.log("inside ws reason");
        this.sympTomsModel.visitReason = this.reasonName.toLowerCase();
      }
       // this.sympTomsModel.visitReason = this.patientpersonalinfo.REASON_NAME.toLowerCase();
        this.sympTomsModel.feverOrChills = "false";
        this.sympTomsModel.cough = "false";
        this.sympTomsModel.shortnessOfBreathDifficultyBreathing = "false";
        this.sympTomsModel.fatigue = "false";
        this.sympTomsModel.muscleOrBodyAches = "false";
        this.sympTomsModel.headache = "false";
        this.sympTomsModel.newLossOfTasteOrSmell = "false";
        this.sympTomsModel.soreThroat = "false";
        this.sympTomsModel.congestionOrRunnyNose = "false";
        this.sympTomsModel.nauseaOrVomiting = "false";
        this.sympTomsModel.diarrhea = "false";
        this.sympTomsModel.diagnosedOrSuspected = "false";
        this.sympTomsModel.travelOutSideNjLastTwoWeak = "false";
        this.phrUtils.patientlanguage$.subscribe(language => {
        this.sympTomsModel.language = language;
        });
        this.onFinishIntakeCall();

        console.log(this.storedIsWithin24Hours);
     /*
      if ((this.patientpersonalinfo.PRACTICE_CODE == '1011163' || this.patientpersonalinfo.PRACTICE_CODE == '100') && this.patientpersonalinfo.REASON_NAME == 'Initial Visit') {
          if (this.storedIsWithin24Hours == 'true') {
            this.submitReason();
          }
        } else {
        if (this.patientpersonalinfo.PRACTICE_CODE != '447' && this.patientpersonalinfo.PRACTICE_CODE != '1010624' && this.patientpersonalinfo.PRACTICE_CODE != '1013142') {
            this.submitReason();
          }
        }*/
        this.isCheckedin = true;
        localStorage.setItem("checkin", this.isCheckedin)
      console.log("is checkin inside ", ischeckin);
      }

    console.log("is checkin outside ", ischeckin);
}

  //status confirm call
  AppointmentStatusConfirmed: any;
  UpdateAppointmentstatus() {
    //tM2hXGTAFn9xY21Pd7JGYg==
    // this.appointmentid;
    //this.spinner.show();
    console.log("status update started");
    const apptid = localStorage.getItem("apptId");
    this.AppointmentStatusConfirmed = 2;
    this._VerifypatientService.ConfirmAppointment(apptid, this.AppointmentStatusConfirmed).subscribe((res: any) => {
      console.log(res)
      if (res.message == "Record Updated") {
        console.log("status update completed");
        localStorage.setItem("updateAppointmentStatus", "true")
      } else {
        console.log("status update failed");
        localStorage.setItem("updateAppointmentStatus", "false")
      }
    }, (error: any) => {
      console.log("status update failed");
      localStorage.setItem("updateAppointmentStatus", "false")
    })
  }


  //create encounter
  CreateICDRequest: any;
  submitReason() {
    const reason = localStorage.getItem("visitReason")
    //console.log(reason);
    if (reason) {
      var reasonValue = this.phrUtils.decrypt(reason)
    }
    let request: any = new requestICD();
    const visitdate = localStorage.getItem('visitDate')
    if (visitdate) {
      request.DOS = localStorage.getItem('visitDate');
    } else {
      //request.DOS = this.InitialQuestionResponce.result.DOS;
      request.DOS = '';
    }
    request.ICDS = "";
    request.SUMMARY = reasonValue;
    request.DOB = this.patientpersonalinfo.DOB;
    request.PROVIDER_CODE = this.patientpersonalinfo.PROVIDER_CODE;
    request.PRACTICE_CODE = this.patientpersonalinfo.PRACTICE_CODE;
    request.TRANSACTION_ID = 0;
    request.PATIENT_ACCOUNT = this.patientpersonalinfo.PATIENT_ACCOUNT;
    request.CREATED_DATE = visitdate;
    request.MODIFIED_DATE = visitdate;
    //request.ROS_CAT_WITH_SYM = [];
    request.DELETED = 0;
    request.R_CODES = "";
    request.DIP_HTML = '',
      request.RISK_HTML = '';
    request.SYM_TO_ROS = '';
    //request.encounter_id = 0;
    this.CreateICDRequest = new CreateICDRequest();
    this.CreateICDRequest.request.push(request);


    let lang = localStorage.getItem('language');
    if (!lang)
      lang = 'en';

    this.SymptomsCheckerService.IcdPredictionSaveData(this.CreateICDRequest, lang).subscribe((res: any) => {

      // console.log(res);
    }, (error: any) => {
   
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });


  }

  //covid call for marking appointment as checkin

  onFinishIntakeCall() {
    console.log("covid call started");
    this.sympTomsModel.first_name = this.patientpersonalinfo.FIRSTNAME;
    this.sympTomsModel.last_name = this.patientpersonalinfo.LASTNAME;
    this.sympTomsModel.patient_account = "" + this.patientpersonalinfo.PATIENT_ACCOUNT;
    this.sympTomsModel.practiceCode = this.patientpersonalinfo.PRACTICE_CODE;
    this.sympTomsModel.appointment_id = "" + this.patientpersonalinfo.APPOINTMENT_ID;
    this.careTeamService.covidQuestionnire(this.sympTomsModel).subscribe((res: any) => {

      if (res && res.statusCode == 200 && res.message == "SUCCESS") {
        console.log("covid call completed");
        if (res.data.status == "link expired") {
          let text = "Link expired.";
          this.translateService.get('Alerts.family_history_linked_expired').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Link expired.");
          this._router.navigateByUrl('/');
        }
        else if (res.data.status == "Success") {
          //this.phrUtils.showSuccess("Saved successfully");
          //this.router.navigateByUrl('patient/thank-you');
        }
        else if (res.data.status == "Fail to insert symtoms") {
          let text = "Failed to insert symtoms.";
          this.translateService.get('Alerts.failed_to_insert_symtoms').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Failed to insert symtoms.");
        }
        else if (res.data.status == "Fail to update appointment") {
          let text = "Failed to update appointment.";
          this.translateService.get('Alerts.failed_to_update_appointment').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          //this.phrUtils.showError("Failed to update appointment.");
        }
        else {
          let text = "Service is not available, please try later.";
          this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
            text = translation;
          });
          this.phrUtils.showError(text);
          // this.phrUtils.showError("Service is not available, please try later.");
        }
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }

  selectBox(boxId: string): void {
   // this.selectedBox = boxId;
    console.log(this.selectedBox);
    if (boxId == 'box1') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.amount = this.paymentDetials.data.amT_DUE;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
          this.selectedBox = boxId;
          console.log(this.amount);
          this.paymentType = "due";
          localStorage.setItem("pType", this.paymentType);
          this.isMinAmount = true;
        } 
      }
     
    } else if (boxId == 'box2') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.amount = this.paymentDetials.data.currentDayAmount;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
          this.selectedBox = boxId;
          console.log(this.amount);
          this.paymentType = "copay";
          localStorage.setItem("pType", this.paymentType);
          this.isMinAmount = true;
        }
      }

    } else if (boxId == 'box3') {
      if (this.selectedBox == boxId) {
        this.selectedBox = "";
        this.amount = '';
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
      } else {
        this.amount = this.paymentDetials.data.totalAmount;
        localStorage.setItem("amt", this.amount);
        this.paymentForm.controls["amount"].setValue(this.amount);
        console.log(this.amount);
        this.selectedBox = boxId;
        this.paymentType = "dueandcopay";
        localStorage.setItem("pType", this.paymentType);
        this.isMinAmount = true;
      }
     
    }
    console.log(this.amount);
  }


  buildpaymentForm() {
    this.paymentForm = new FormGroup({
      amount: new FormControl('', [Validators.required, Validators.max(4999)]),
    });
  }

  //get payment form controls for validations/manipulations
  get getpaymentForm() {
    return this.paymentForm.controls;
  }

  validateCurreny(e: any): boolean {
    //this.checkAmountInput(e);
    let curr = e.target.value;

    let dotExists = curr.indexOf('.') > -1 ? true : false;
    if (e.keyCode > 47 && e.keyCode < 58) {
      if (dotExists && curr.length == (curr.indexOf('.') + 3)) {
        return false;
      }
      else if (dotExists && curr.length < (curr.indexOf('.') + 3)) {
        return true;
      }
      if (Number(curr + e.key) <= 9999.99) {
        return true;
      }
      return false;
    }
    else if (e.keyCode === 46) {
      if (dotExists) {
        return false;
      }
      return true;
    }
    // else if(!this.isNewPatient && Number(curr + e.key ) > Number(this.paymentDetials.data.amT_DUE)){
    //   return true;
    // }
    else {
      return false;
    }
  }
  onClickBack(){
    this._router.navigateByUrl("patient/intake/past-hospitalization-history");
  }
  payCopay() {
    this.phrUtils.updateAmount(this.paymentDetials.data.currentDayAmount);
    this._router.navigateByUrl("patient/payment");
  }

  payTotalBalance() {
    this.phrUtils.updateAmount(this.paymentDetials.data.totalAmount);
    this._router.navigateByUrl("patient/payment");
  }
  checkAmountInput(event: any) {
    const amt = event.target.value;
    console.log("amunt ", amt);
    console.log("select box ", this.selectedBox);
    if (this.selectedBox) {
      if (amt.length > 0) {
        this.selectedBox = '';
      }
    }
    if (amt < Number(this.paymentDetials.data.currentDayAmount)) {
      this.isMinAmount = false;
    } else {
      this.isMinAmount = true;
    }
  }

  onClickNext() {
    const amount = this.getpaymentForm['amount'].value;
    if (this.isCopay == true && this.isoutstanding == false) {
      this.amount = this.paymentDetials.data.currentDayAmount;
      this.selectedBox = 'box2';
      localStorage.setItem("amt", this.amount);
      this.paymentType = "copay";
      localStorage.setItem("pType", this.paymentType);
      this._router.navigateByUrl("patient/payment");
    } else {
      if (this.isCopay == true && this.isoutstanding == true && this.selectedBox == '') {
        if (amount <= Number(this.paymentDetials.data.currentDayAmount)) {
          this.paymentType = "copay";
          localStorage.setItem("pType", this.paymentType);
        } else {
          this.paymentType = "dueandcopay";
          localStorage.setItem("pType", this.paymentType);
        }
         
      }
      if (Number(this.paymentDetials.data.totalAmount) <= 0) {
        let text = "No dues to pay.";
        this.translateService.get('Alerts.no_dues_to_pay').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showWarning(text);
        //this.phrUtils.showWarning('No dues to pay.');
      } else if (amount.length == 0) {
        let text = "Please select / enter Amount";
        this.translateService.get('Alerts.select_enter_amount').subscribe((translation: string) => {
          text = translation;
        });
        this.phrUtils.showWarning(text);
      }
      else {
        this.paymentForm.markAllAsTouched();
        if (this.paymentForm.invalid) {
          return;
        }
        console.log("amount ", amount)
        console.log("amount due ", this.amountDueTemp)
        if (amount > this.amountDueTemp) {
          return;
        }
        if (!this.isMinAmount) {
          return;
        } 
        if (this.isCopay == false && this.isoutstanding == true) {
          this.paymentType = "due";
          localStorage.setItem("pType", this.paymentType);
        }

        // this.phrUtils.updateAmount(this.amount);
        localStorage.setItem("amt", amount);
        this._router.navigateByUrl("patient/payment");
      }
    }
   
  }

  isMinuDueAmount: string = "false";
  isMinuTotalAmount: string = "false";
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  getPaymentDetails(){
    this.spinner.show();
    this.service.getPaymentDetails(this.patientpersonalinfo.PRACTICE_CODE, this.patientpersonalinfo.PATIENT_ACCOUNT, this.appointmentId).subscribe((res: any) => {
      this.spinner.hide();
      //   { "statusCode": 200, "message": "SUCCESS","data": { "amT_DUE": "492.90", "currentDayAmount": "0.00",
      //         "totalAmount": "492.90",
      //         "prI_SEC_OTH_TYPE": "P", "id": "1", "inspayeR_DESCRIPTION": "MEDICARE ADVANTAGE", "visit_Date": "",
      //         "visit_Reasons": ""  } }
      if(res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data){
        this.paymentDetials = res as PaymentDeiails;
        this.amountDueTemp = Number(this.paymentDetials.data.totalAmount);

        // execute incase of already check-in
        /*
        if (this.paymentDetials.data.totalAmount != null && this.paymentDetials.data.totalAmount != "") {
         if (this.AppointmentStatusId == "15") {
            this.hidebackButton = true;
           this.showMessage = true;
          }
        } */
        if(Number(this.paymentDetials.data.totalAmount) < 0 && this.paymentDetials.data.totalAmount.includes('-'))
        {
          this.isMinuTotalAmount = this.paymentDetials.data.totalAmount.replace('-','');
          this.isMinuTotalAmount = Number(this.isMinuTotalAmount).toLocaleString();
        }
        if(Number(this.paymentDetials.data.amT_DUE) < 0 && this.paymentDetials.data.amT_DUE.includes('-'))
        {
          this.isMinuDueAmount = this.paymentDetials.data.amT_DUE.replace('-','');
          this.isMinuDueAmount = Number(this.isMinuDueAmount).toFixed(2).toLocaleString();
        }
        this.paymentDetials.data.amT_DUE = Number(this.paymentDetials.data.amT_DUE).toFixed(2).toLocaleString();
        this.paymentDetials.data.totalAmount = Number(this.paymentDetials.data.totalAmount).toFixed(2).toLocaleString();
        if (Number(this.paymentDetials.data.currentDayAmount) > 0) {
          this.isCopay = true;
        } else {
          this.isCopay = false;
        }
        if (Number(this.paymentDetials.data.amT_DUE) > 0) {
          this.isoutstanding = true;
        } else {
          this.isoutstanding = false;
        }
        if (this.isCopay == true && this.isoutstanding==false) {
          this.ShowAmountField = false;
        }
        /*
        if (this.isCopay == true && this.isoutstanding == false) {
          this.selectedBox = 'box2'
          this.amount = this.paymentDetials.data.currentDayAmount;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
        } else if (this.isCopay == false && this.isoutstanding == true) {
          this.selectedBox = 'box1';
          this.amount = this.paymentDetials.data.amT_DUE;
          localStorage.setItem("amt", this.amount);
          this.paymentForm.controls["amount"].setValue(this.amount);
        }*/
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }
  onFinishIntake() {
    localStorage.setItem("noIntakeForm", "true");
    this._router.navigateByUrl('patient/thank-you');
  }
}
